import React, { useState, useEffect } from 'react';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabase';

const CATEGORIES = ['All', 'Courses', 'Books', 'Prints', 'Sessions'];

// Helper to check if mobile view
const isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 480px)').matches;

function Shop() {
  const [category, setCategory] = useState('All');
  const [cart, setCart] = useState([]);
  const [showCheckout, setShowCheckout] = useState(false);
  const [shipping, setShipping] = useState(0);
  const [country, setCountry] = useState('');
  const [orderPlaced, setOrderPlaced] = useState(false);
  const [checkoutProduct, setCheckoutProduct] = useState(null);
  const [showThankYou, setShowThankYou] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  // Load products from localStorage or use default
  useEffect(() => {
    const savedProducts = localStorage.getItem('shopProducts');
    if (savedProducts) {
      setProducts(JSON.parse(savedProducts));
    } else {
      // Initialize with existing products if none in localStorage
      const defaultProducts = [
        { id: 1, name: 'Chakra Balancing Mastery', category: 'Courses', price: 89.99, stock: 12, digital: true, img: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80' },
        { id: 2, name: 'Sacred Oracle Deck', category: 'Books', price: 29.99, stock: 0, digital: true, img: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=400&q=80' },
        { id: 3, name: 'Chakra Art Collection', category: 'Prints', price: 19.99, stock: 5, digital: true, img: 'https://images.unsplash.com/photo-1464983953574-0892a716854b?auto=format&fit=crop&w=400&q=80' },
        { id: 4, name: 'Energy Healing Session', category: 'Sessions', price: 59.99, stock: 8, digital: false, img: 'https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=400&q=80' },
        { id: 5, name: 'Moon Phase Oracle Deck', category: 'Books', price: 39.99, stock: 3, digital: true, img: 'https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=400&q=80' },
        { id: 6, name: 'Custom Destiny Card Print', category: 'Prints', price: 24.99, stock: 2, digital: false, img: 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80' },
        { id: 7, name: 'Sacred Geometry Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/025M3Y7J/Whats-App-Image-2025-07-24-at-8-54-24-PM.jpg' },
        { id: 8, name: 'Mystical Moon Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/8z97jx9h/Whats-App-Image-2025-07-24-at-9-19-22-PM.jpg' },
        { id: 9, name: 'Rose Quartz Healing Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/CxzZMwPh/Whats-App-Image-2025-07-24-at-9-19-23-PM-1.jpg' },
        { id: 10, name: 'Amethyst Spiritual Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/bN6DjZRV/Whats-App-Image-2025-07-24-at-9-19-23-PM-2.jpg' },
        { id: 11, name: 'Citrine Abundance Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/rmCsZsmJ/Whats-App-Image-2025-07-25-at-6-52-22-PM.jpg' },
        { id: 12, name: 'Lapis Lazuli Wisdom Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/PJSxh71v/Whats-App-Image-2025-07-25-at-6-52-22-PM-1.jpg' },
        { id: 13, name: 'Tiger Eye Protection Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/1tZ4Kw9X/Whats-App-Image-2025-07-25-at-6-52-22-PM-2.jpg' },
        { id: 14, name: 'Clear Quartz Master Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/GmWpcGTK/Whats-App-Image-2025-07-25-at-6-52-23-PM.jpg' },
        { id: 15, name: 'Black Obsidian Grounding Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/Wb4zS2PG/Whats-App-Image-2025-07-25-at-6-52-23-PM-1.jpg' },
        { id: 16, name: 'Green Aventurine Luck Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/c1h6QvP1/Whats-App-Image-2025-07-25-at-6-52-23-PM-2.jpg' },
        { id: 17, name: 'Selenite Cleansing Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/cCxHpWtN/Whats-App-Image-2025-07-25-at-6-52-23-PM-3.jpg' },
        { id: 18, name: 'Malachite Transformation Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/sXyDWzcZ/Whats-App-Image-2025-07-25-at-6-52-24-PM.jpg' },
        { id: 19, name: 'Labradorite Magic Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/Gpvm9tkC/Whats-App-Image-2025-07-25-at-6-52-24-PM-1.jpg' },
        { id: 20, name: 'Carnelian Vitality Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/L60XbrHr/Whats-App-Image-2025-07-25-at-6-52-24-PM-2.jpg' },
        { id: 21, name: 'Fluorite Clarity Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/3rtJkPDd/Whats-App-Image-2025-07-25-at-6-52-25-PM.jpg' },
        { id: 22, name: 'Hematite Strength Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/T1NRBDXr/Whats-App-Image-2025-07-25-at-6-52-25-PM-1.jpg' },
        { id: 23, name: 'Jade Harmony Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/j5XqQ1g3/Whats-App-Image-2025-07-25-at-6-52-25-PM-2.jpg' },
        { id: 24, name: 'Healing Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/rwf5whNT/Whats-App-Image-2025-07-23-at-10-10-16-PM.jpg' },
        { id: 25, name: 'Spiritual Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/nLMBjv3D/Whats-App-Image-2025-07-23-at-10-10-17-PM.jpg' },
        { id: 26, name: 'Mystical Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/3w6pgdqb/Whats-App-Image-2025-07-23-at-10-13-17-PM.jpg' },
        { id: 27, name: 'Sacred Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/MTQBtz2Z/Whats-App-Image-2025-07-23-at-10-22-29-PM.jpg' },
        { id: 28, name: 'Divine Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/rs2rP7M1/Whats-App-Image-2025-07-23-at-10-42-37-PM.jpg' },
        { id: 29, name: 'Ancient Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/pThf7D8H/Whats-App-Image-2025-07-23-at-5-28-43-PM.jpg' },
        { id: 30, name: 'Cosmic Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/R00Q1rZq/Whats-App-Image-2025-07-23-at-5-28-43-PM-1.jpg' },
        { id: 31, name: 'Ethereal Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/kgqy4RrQ/Whats-App-Image-2025-07-23-at-5-28-43-PM-2.jpg' },
        { id: 32, name: 'Celestial Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/FRMyQ7gJ/Whats-App-Image-2025-07-23-at-5-28-44-PM.jpg' },
        { id: 33, name: 'Enchanted Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/y8jyS6Bw/Whats-App-Image-2025-07-23-at-5-28-44-PM-1.jpg' },
        { id: 34, name: 'Magical Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/1zY0JW8B/Whats-App-Image-2025-07-23-at-5-28-44-PM-2.jpg' },
        { id: 35, name: 'Serene Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/3rGjFFYj/Whats-App-Image-2025-07-23-at-5-28-45-PM.jpg' },
        { id: 36, name: 'Tranquil Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/rs5SyMQZ/Whats-App-Image-2025-07-23-at-6-32-42-PM.jpg' },
        { id: 37, name: 'Peaceful Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/wTdXfRjC/Whats-App-Image-2025-07-23-at-9-36-17-PM.jpg' },
        { id: 38, name: 'Calming Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/wjqhHKJF/Whats-App-Image-2025-07-23-at-9-36-18-PM.jpg' },
        { id: 39, name: 'Soothing Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/m2NQ0Zct/Whats-App-Image-2025-07-23-at-9-36-18-PM-1.jpg' },
        { id: 40, name: 'Harmonious Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/KctLMcDJ/Whats-App-Image-2025-07-24-at-4-00-53-PM.jpg' },
        { id: 41, name: 'Balanced Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/nrKDbTh6/Whats-App-Image-2025-07-24-at-6-38-29-PM.jpg' },
        { id: 42, name: 'Centered Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/hPrd2Cwm/Whats-App-Image-2025-07-24-at-6-38-31-PM.jpg' },
        { id: 43, name: 'Aligned Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/9FV9t3xV/Whats-App-Image-2025-07-24-at-6-42-26-PM.jpg' },
        { id: 44, name: 'Connected Crystal Print', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/6ppGgrJm/Whats-App-Image-2025-07-24-at-7-21-15-PM.jpg' },
        { id: 45, name: 'Mystical Energy Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/6pbGX8B5/Whats-App-Image-2025-07-24-at-7-21-40-PM.jpg' },
        { id: 46, name: 'Sacred Light Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/7LCJYqL1/Whats-App-Image-2025-07-24-at-7-34-17-PM.jpg' },
        { id: 47, name: 'Divine Protection Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/QMR9FvB2/Whats-App-Image-2025-07-24-at-8-13-42-PM.jpg' },
        { id: 48, name: 'Spiritual Awakening Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/5ym6k0PJ/Whats-App-Image-2025-07-24-at-8-13-43-PM.jpg' },
        { id: 49, name: 'Cosmic Wisdom Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/hvnXrx1M/Whats-App-Image-2025-07-24-at-8-13-43-PM-1.jpg' },
        { id: 50, name: 'Ethereal Beauty Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/W3gDgSgh/Whats-App-Image-2025-07-24-at-8-13-43-PM-2.jpg' },
        { id: 51, name: 'Enchanted Spirit Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/sfPQ263L/Whats-App-Image-2025-07-24-at-8-13-44-PM.jpg' },
        { id: 52, name: 'Magical Essence Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/zXJLHCBG/Whats-App-Image-2025-07-24-at-8-13-53-PM.jpg' },
        { id: 53, name: 'Celestial Harmony Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/XYPXPtgr/Whats-App-Image-2025-07-24-at-8-44-55-PM.jpg' },
        { id: 54, name: 'Mystical Aura Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/yNSW-Cnfv/Whats-App-Image-2025-07-24-at-8-44-56-PM-2.jpg' },
        { id: 55, name: 'Sacred Essence Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/C1T5hDXY/Whats-App-Image-2025-07-24-at-8-44-56-PM-1.jpg' },
        { id: 56, name: 'Divine Radiance Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/zBCBVvYh/Whats-App-Image-2025-07-24-at-8-44-56-PM.jpg' },
        { id: 57, name: 'Spiritual Serenity Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/CLmRGRBH/Whats-App-Image-2025-07-24-at-8-44-55-PM-2.jpg' },
        { id: 58, name: 'Cosmic Tranquility Crystal', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/Z5nCVJ6k/Whats-App-Image-2025-07-24-at-8-44-55-PM-1.jpg' },
        { id: 59, name: 'Mystical Crystal Art', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/mDbBDwLY/Whats-App-Image-2025-07-26-at-7-22-25-PM-1.jpg' },
        { id: 60, name: 'Sacred Crystal Design', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/JhC1w8Sd/Whats-App-Image-2025-07-26-at-7-22-25-PM-2.jpg' },
        { id: 61, name: 'Divine Crystal Pattern', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/HWvdYXfM/Whats-App-Image-2025-07-26-at-7-22-26-PM.jpg' },
        { id: 62, name: 'Spiritual Crystal Essence', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/tJJbd4V7/Whats-App-Image-2025-07-26-at-7-22-26-PM-1.jpg' },
        { id: 63, name: 'Cosmic Crystal Energy', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/zX9NW5DX/Whats-App-Image-2025-07-26-at-7-22-27-PM.jpg' },
        { id: 64, name: 'Ethereal Crystal Beauty', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/CLZYzdgQ/Whats-App-Image-2025-07-26-at-7-22-27-PM-1.jpg' },
        { id: 65, name: 'Mystical Crystal Harmony', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/yNTCwZmk/Whats-App-Image-2025-07-26-at-7-22-30-PM.jpg' },
        { id: 66, name: 'Sacred Crystal Radiance', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/DwLTPDmQ/Whats-App-Image-2025-07-26-at-7-22-30-PM-1.jpg' },
        { id: 67, name: 'Divine Crystal Serenity', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/MTKJxp5t/Whats-App-Image-2025-07-26-at-7-22-31-PM.jpg' },
        { id: 68, name: 'Spiritual Crystal Wisdom', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/vT4Rg2pV/Whats-App-Image-2025-07-29-at-7-12-34-PM.jpg' },
        { id: 69, name: 'Cosmic Crystal Balance', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/XJHSv6DW/Whats-App-Image-2025-07-29-at-7-12-34-PM-1.jpg' },
        { id: 70, name: 'Ethereal Crystal Essence', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/qqSP8XTZ/Whats-App-Image-2025-07-31-at-8-49-07-PM.jpg' },
        { id: 71, name: 'Mystical Crystal Tranquility', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/T3M819QK/Whats-App-Image-2025-07-31-at-8-49-08-PM.jpg' },
        { id: 72, name: 'Sacred Crystal Peace', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/ZKytJgPk/Whats-App-Image-2025-07-31-at-8-49-08-PM-1.jpg' },
        { id: 73, name: 'Divine Crystal Calm', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/fWPQnZ9j/Whats-App-Image-2025-07-31-at-8-49-08-PM-2.jpg' },
        { id: 74, name: 'Spiritual Crystal Enlightenment', category: 'Prints', price: 2.00, stock: 15, digital: true, img: 'https://i.postimg.cc/13pkqqYJ/Whats-App-Image-2025-08-05-at-9-06-42-PM.jpg' }
      ];
      setProducts(defaultProducts);
      localStorage.setItem('shopProducts', JSON.stringify(defaultProducts));
    }
  }, []);

  // Listen for changes in localStorage to update products
  useEffect(() => {
    const handleStorageChange = () => {
      const savedProducts = localStorage.getItem('shopProducts');
      if (savedProducts) {
        setProducts(JSON.parse(savedProducts));
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const filtered = category === 'All' ? products : products.filter(p => p.category === category);

  const addToCart = (product) => {
    if (product.stock === 0) return;
    setCart(prev => {
      const found = prev.find(item => item.id === product.id);
      if (found) {
        return prev.map(item => item.id === product.id ? { ...item, qty: item.qty + 1 } : item);
      }
      return [...prev, { ...product, qty: 1 }];
    });
  };

  const removeFromCart = (id) => {
    setCart(cart.filter(item => item.id !== id));
  };

  const updateQty = (id, qty) => {
    setCart(cart.map(item => item.id === id ? { ...item, qty: Math.max(1, qty) } : item));
  };

  const calcShipping = (country) => {
    if (!country) return 0;
    if (country.toLowerCase() === 'kuwait') return 2.5;
    if (country.toLowerCase() === 'usa') return 7.5;
    return 12.0;
  };

  const handleBuyNow = (product) => {
    setCheckoutProduct(product);
    setShowCheckout(true);
  };

  const handleCheckout = async (e) => {
    e.preventDefault();
    
    const formData = new FormData(e.target);
    const customerName = formData.get('customerName') || 'Anonymous';
    const email = formData.get('email') || '';
    const phone = formData.get('phone') || '';
    
    // Save order to Supabase
    const orderData = {
      customer_name: customerName,
      email: email,
      phone: phone,
      product_name: checkoutProduct.name,
      product_id: checkoutProduct.id,
      product_category: checkoutProduct.category,
      amount: parseFloat(checkoutProduct.price.toFixed(2)),
      shipping: checkoutProduct.digital ? 0 : shipping,
      total: parseFloat(total.toFixed(2)),
      country: country || null,
      is_digital: checkoutProduct.digital || false,
      status: 'pending'
    };
    
    try {
      const { error } = await supabase
        .from('shop_orders')
        .insert([orderData]);
      
      if (error) throw error;
      
      // Also save to localStorage for backward compatibility
      const order = {
        date: new Date().toLocaleDateString(),
        customerName: customerName,
        productName: checkoutProduct.name,
        amount: checkoutProduct.price.toFixed(2),
        status: 'pending'
      };
      
      const existingOrders = JSON.parse(localStorage.getItem('shopOrders') || '[]');
      existingOrders.push(order);
      localStorage.setItem('shopOrders', JSON.stringify(existingOrders));
      
      setOrderPlaced(true);
      setTimeout(() => {
        setOrderPlaced(false);
        setShowCheckout(false);
        setShowThankYou(true);
      }, 1200);
    } catch (error) {
      console.error('Error saving order:', error);
      // Still show success to user even if Supabase fails
      setOrderPlaced(true);
      setTimeout(() => {
        setOrderPlaced(false);
        setShowCheckout(false);
        setShowThankYou(true);
      }, 1200);
    }
  };

  const subtotal = checkoutProduct ? checkoutProduct.price : 0;
  const total = subtotal + (checkoutProduct && !checkoutProduct.digital ? shipping : 0);

  return (
    <div className="main-bg">
      {/* Hide hero-section on mobile */}
      {!isMobile && (
        <header className="hero-section">
          <h1 className="site-title">Shop</h1>
          <p className="site-tagline">Browse and purchase courses, books, prints, and sessions</p>
        </header>
      )}
      <div className="shop-container">
        {!showCheckout && !showThankYou && (
          <>
            <div className="shop-filters">
              {CATEGORIES.map(cat => (
                <button
                  key={cat}
                  className={`shop-filter-btn${category === cat ? ' active' : ''}`}
                  onClick={() => setCategory(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
            <div className="shop-products">
              {filtered.map(product => (
                <div key={product.id} className="shop-product-card">
                  <img src={product.img} alt={product.name} className="shop-product-img" />
                  <h3>{product.name}</h3>
                  <div className="shop-product-meta">
                    <span className="shop-product-category">{product.category}</span>
                    <span className="shop-product-price">${product.price.toFixed(2)}</span>
                  </div>
                  <div className="shop-product-stock">
                    {product.stock > 0 ? (
                      <span className="in-stock">In Stock</span>
                    ) : (
                      <span className="out-stock">Out of Stock</span>
                    )}
                  </div>
                  <button
                    className="planner-btn shop-buy-btn"
                    disabled={product.stock === 0}
                    onClick={() => handleBuyNow(product)}
                  >
                    Order Now
                  </button>
                </div>
              ))}
            </div>
          </>
        )}
        {showCheckout && checkoutProduct && (
          <div className="shop-cart-modal">
            <h2>Checkout</h2>
            <div className="shop-product-card" style={{ boxShadow: 'none', border: 'none', padding: 0 }}>
              <img src={checkoutProduct.img} alt={checkoutProduct.name} className="shop-product-img" />
              <h3>{checkoutProduct.name}</h3>
              <div className="shop-product-meta">
                <span className="shop-product-category">{checkoutProduct.category}</span>
                <span className="shop-product-price">${checkoutProduct.price.toFixed(2)}</span>
              </div>
            </div>
            <form className="shop-checkout-form" onSubmit={handleCheckout}>
              <input type="text" name="customerName" placeholder="Full Name" required className="shop-checkout-input" />
              <input type="email" name="email" placeholder="Email Address" required className="shop-checkout-input" />
              <input type="tel" name="phone" placeholder="Phone Number" required className="shop-checkout-input" />
              <div className="shop-cart-summary">
                <div>Subtotal: ${subtotal.toFixed(2)}</div>
                {!checkoutProduct.digital && <div>Shipping: ${shipping.toFixed(2)}</div>}
                <div className="shop-cart-total">Total: ${total.toFixed(2)}</div>
              </div>
              <button className="planner-btn" type="submit">Submit</button>
            </form>
            {orderPlaced && <div className="custom-success">Your contact info has been received. Our team will contact you shortly.</div>}
          </div>
        )}
        {showThankYou && (
          <div className="shop-cart-modal" style={{ textAlign: 'center' }}>
            <h2>Thank You!</h2>
            <p>Your contact info has been received. Our team will contact you shortly.</p>
            <button className="planner-btn" onClick={() => setShowThankYou(false)}>Back to Shop</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Shop; 